import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Home from './pages/Home'
import B2B from './pages/B2B'
import B2C from './pages/B2C'
import Footer from './components/Footer'

// 메인 App 컴포넌트 - 라우팅과 전체 레이아웃 관리
function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 font-korean">
        {/* 상단 네비게이션 헤더 */}
        <Header />
        
        {/* 메인 콘텐츠 영역 */}
        <main className="flex-1">
          <Routes>
            {/* 루트 경로 - 홈페이지 */}
            <Route path="/" element={<Home />} />
            {/* B2B 페이지 - 기관 대상 강의 섭외 */}
            <Route path="/b2b" element={<B2B />} />
            {/* B2C 페이지 - 개인 대상 챌린지 프로그램 */}
            <Route path="/b2c" element={<B2C />} />
          </Routes>
        </main>
        
        {/* 하단 푸터 */}
        <Footer />
      </div>
    </Router>
  )
}

export default App
